"use client";

import { usePathname } from "next/navigation";

export default function Footer() {
  const pathname = usePathname();
  if (pathname === "/login") return null;
  return (
    <footer className="hidden border-t py-6 text-center text-xs text-muted-foreground sm:block">
      基于《赖氏经典英语语法》· 每日一练，从体系出发
    </footer>
  );
}
